<template>
	<modal size="extra-large" class="modal-help" @close="close" v-if="show">
		<div slot="header">
			<h3>{{ $t('help') }}</h3>
		</div>
		<div slot="body" class="p-0">
			<div class="search-group">
				<div class="action-search-icon inline-item">
					<i class="material-icons">search</i>
				</div>
				<div class="action-search inline-item">
					<md-field class="md-field">
						<label>{{ $t('search') }}</label>
						<md-input type="text" v-model="searchTitle"></md-input>
					</md-field>
				</div>
			</div>
			<div id="accordion" class="digidaw-accordion" v-if="filteredArticles.length > 0">
				<div class="card digidaw-item" v-for="(article, index) in filteredArticles" :key="index">
					<a class="card-link" data-toggle="collapse" :href="'#article-'+index">
						<div class="card-header">{{ article.title }}</div>
					</a>
					<div :id="'article-'+index" class="collapse">
						<div class="card-body">
							<div class="ql-editor accordion-content" v-html="article.content"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="empty-list" v-if="filteredArticles.length === 0 && !isFetching">
				<div class="empty-list-icon">
					<i class="material-icons">description</i>
				</div>
				{{ $t('noArticlesAvailable') }}
			</div>

			<div class="is-loading large p-5" v-if="isFetching"></div>
		</div>
		<div slot="footer">
			<div class="modal-actions clearfix">
				<div class="float-right">
					<button type="button" class="btn btn-lg btn-secondary btn-save raised" @click="close">
						{{ $t('close') }}
					</button>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import Modal from './Modal.vue';
import articleApi from '../api/articles';

export default {
	name: 'ModalHelp',
	components: {
		Modal,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		suggestion: {
			type: Object,
		},
	},
	data() {
		return {
			isFetching: false,
			articles: [],
			searchTitle: '',
			sortBy: 'created_at',
			sort: 'asc',
			limit: 25,
		};
	},
	mounted() {},
	created() {},
	methods: {
		close() {
			this.$emit('close');
		},
		getArticles() {
			const params = {
				sort_by: this.sortBy,
				sort: this.sort,
				limit: this.limit,
				keyword: this.searchTitle,
			};
			if (this.eventSlug) params.event_slug = this.eventSlug;
			const callback = (response) => {
				const articles = response.data;
				this.articles = articles;
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
			};
			articleApi.getList(params, callback, errorCallback);
			if (this.articles.length === 0) this.isFetching = true;
		},
	},
	computed: {
		location() {
			const location = this.$store.getters.location;
			return location;
		},
		filteredArticles() {
			const keyword = this.searchTitle.toLowerCase();
			const filter = (item) => {
				const title = item.title.toLowerCase();
				const isTitleMatched = title.indexOf(keyword) !== -1;
				// let isLocationMatched = false;
				// const locationName = this.location.to.name;
				// if (locationName !== '') {
				// 	if (locationName === 'EventNow') {
				// 		if (item.category.type === 'now' || item.category.type === 'suggestions' || item.category.type === 'speechlist') isLocationMatched = true;
				// 	} else if (locationName === 'AdminEvents') {
				// 		if (item.category.type === 'admin_events') isLocationMatched = true;
				// 	} else if (locationName === 'EventReport') {
				// 		if (item.category.type === 'reports') isLocationMatched = true;
				// 	} else if (locationName === 'EventSuggestionsProcessing') {
				// 		if (item.category.type === 'suggestions_processing') isLocationMatched = true;
				// 	} else if (locationName === 'EventParticipant') {
				// 		if (item.category.type === 'participants') isLocationMatched = true;
				// 	} else if (locationName === 'EventAgenda') {
				// 		if (item.category.type === 'agenda') isLocationMatched = true;
				// 	} else if (locationName === 'AdminArticles') {
				// 		if (item.category.type === 'articles') isLocationMatched = true;
				// 	} else if (locationName === 'AdminClients') {
				// 		if (item.category.type === 'admin_clients') isLocationMatched = true;
				// 	} else if (locationName === 'AdminUsers') {
				// 		if (item.category.type === 'admin_users') isLocationMatched = true;
				// 	} else if (locationName === 'AdminArticles') {
				// 		if (item.category.type === 'admin_articles') isLocationMatched = true;
				// 	} else if (locationName === 'UserProfile') {
				// 		if (item.category.type === 'user_profile') isLocationMatched = true;
				// 	} else if (item.category.type === 'general') isLocationMatched = true;
				// }
				// const isMatched = isTitleMatched && isLocationMatched;
				const isMatched = isTitleMatched;
				return isMatched;
			};
			const filtered = this.articles.filter(filter);
			return filtered;
		},
		eventSlug() {
			return this.$route.params.eventSlug;
		},
	},
	watch: {
		eventSlug() {
			// this.getArticles();
		},
		show() {
			if (this.show) this.getArticles();
			else this.articles = [];
		},
	},
};
</script>
<style lang="scss">
</style>
